const SPOTIFY_BASE_URL_1 = "https://accounts.spotify.com";
const SPOTIFY_BASE_URL_2 = "https://api.spotify.com";
const SPOTIFY_CLIENT_ID = "c48ef4f928e443699a5a47ab614734db";
const SPOTIFY_CLIENT_SECRET = "de45d8b008da4af3bf82f50749542e91";
const SPOTIFY_grant_type = "client_credentials";

export const SpotifyContentType = Object.freeze({
    ALBUM: 'album',
    ARTIST: 'artist',
    PLAYLIST: 'playlist',
    TRACK: 'track',
    SHOW: 'show',
    EPISODE: 'episode',
    AUDIOBOOK: 'audiobook',
});

const API_VER_SPOTIFY = {
    VERSION : `${SPOTIFY_BASE_URL_2}/v1`,
}

const ROUTES_SPOTIFY = {
    API : `${SPOTIFY_BASE_URL_1}/api`,
    BROWSE : `${API_VER_SPOTIFY.VERSION}/browse`
}

const ENDPOINT_SPOTIFY = {
    AUTH_TOKEN : `${ROUTES_SPOTIFY.API}/token`,
    CATEGORIES : `${ROUTES_SPOTIFY.BROWSE}/categories`,
    NEW_RELEASE : `${ROUTES_SPOTIFY.BROWSE}/new-releases`,
    SEARCH : `${API_VER_SPOTIFY.VERSION}/search`,
    TRACKS : `${API_VER_SPOTIFY.VERSION}/tracks`,
    ARTISTS : `${API_VER_SPOTIFY.VERSION}/artists`,
    ALBUMS : `${API_VER_SPOTIFY.VERSION}/albums`,
}

export default {SPOTIFY_BASE_URL_1,SPOTIFY_BASE_URL_2,SPOTIFY_CLIENT_ID,SPOTIFY_CLIENT_SECRET,SPOTIFY_grant_type,ENDPOINT_SPOTIFY}